import React from "react";
import { Route, Routes } from "react-router-dom";
import { LayoutAuth } from "../layout";
import { FormContainer, FormRestorePassword, RestorePassword } from "../pages/auth";
import { PublicPath } from "./paths";

export const PublicRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<LayoutAuth />}>
                <Route index element={<FormContainer />} />
                <Route path={PublicPath.restorePassword} element={<RestorePassword />} />
                <Route path={PublicPath.newPassword} element={<FormRestorePassword />} />
            </Route>
        </Routes>
    );
};
